import { useMapEvents } from "react-leaflet";

type Props = {
    setFocusedPosition: (pos: [number, number] | null) => void
}

// Componente que se encarga de manejar los eventos del mapa
const MapEventsHandler = ({ setFocusedPosition }: Props) => {
    useMapEvents({
        zoomstart: () => setFocusedPosition(null), // Al hacer zoom se quita el foco de la posición
        zoomend: () => setFocusedPosition(null), // Al terminar de hacer zoom se quita el foco de la posición
    });
    return null;
};

export default MapEventsHandler;